// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.awAtq{position:relative;padding-bottom:56.25%;height:0}.awAtq iframe{position:absolute;top:0;left:0;width:100%;height:100%;display:block}.RCgMT{padding-top:15px}.VE07W{padding-top:0;text-align:justify}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"videoContainer": `awAtq`,
	"videoTitle": `RCgMT`,
	"videoDescription": `VE07W`
};
module.exports = ___CSS_LOADER_EXPORT___;
